<script>
import { enums as highlightEnums, highlights } from './Highlights'
import SvgIcon from '~/components/SvgIcon.vue'
import highlightIcons from '~/icons/vehicleHighlight'
import carfaxLogo from '~/icons/vehicleHighlight/CARFAX_LOGO.svg'

export default {
  name: 'VehicleHighlight',
  components: {
    SvgIcon
  },
  props: {
    badge: { type: Boolean, default: false },
    highlight: {
      type: String,
      required: true,
      validator: value => highlightEnums.includes(value)
    }
  },
  data: () => ({ carfaxLogo }),
  computed: {
    highlightContent: vm => highlights[vm.highlight],
    highlightIcon: vm => highlightIcons[vm.highlight] || {}
  }
}
</script>

<template>
  <div
    v-if="highlightContent"
    class="vehicle-highlight"
    :style="{ backgroundColor: badge && highlightContent.backgroundColor }"
    :class="{
      'vehicle-highlight--description-wrapper__small-badge px-1': badge,
      'pa-2': !badge
    }"
  >
    <SvgIcon
      class="vehicle-highlight--icon"
      :src="highlightIcon"
    />
    <div
      v-if="!badge"
      class="vehicle-highlight--description-wrapper ml-4"
    >
      <SvgIcon
        v-if="highlightContent.carfaxLogo && !badge"
        class="vehicle-highlight--carfax-logo"
        :src="carfaxLogo"
      />
      <p class="vehicle-highlight--title font-weight-bold text-body-1 mb-1">
        {{ highlightContent.title }}
      </p>
      <p class="vehicle-highlight--description grey--text text--darken-3 text-body-1">
        {{ highlightContent.description }}
      </p>
    </div>
    <p
      v-if="badge"
      class="ml-1 vehicle-highlight--title__small ma-0 text-body-2"
    >
      <span v-if="highlightContent.carfaxLogo">CARFAX</span>
      {{ highlightContent.title }}
    </p>
  </div>
</template>

<style lang="scss">
.vehicle-highlight {
  display: flex;
  position: relative;

  &--carfax-logo {
    height: 44px;
  }

  &--title {
    line-height: 26px;
  }

  &--title__small {
    width: fit-content;
    white-space: nowrap;
  }

  &--description-wrapper {
    display: flex;
    flex-direction: column;
  }

  .vehicle-highlight--icon {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
  }

  &--description-wrapper__small-badge {
    background-color: #E3ECF3;
    align-items: center;

    .vehicle-highlight--icon {
      margin: 1px;
      width: 22px;
      height: 22px;
    }
  }
}
</style>
